<template>
  <div class="score">
    <div class="container">
      <div v-if="gameData != null">
        <h3 class="is-size-2">{{ gameData.title }}</h3>
        <h3 class="is-size-5">{{ gameData.dateTimeStamp | formatDateTime }}</h3>
        <GameSummary ref="gameSummary" v-bind:gameData="gameData"/> 
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GameSummary from "../components/GameSummary.vue";

export default {
  name: 'scorecard',
    components : {
      GameSummary
    },
    computed: {
    },
    data () {
        return {
          debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
          publicPath: process.env.BASE_URL,
          gameData: null,
          isLoading: true
        }
    },
    methods:{
      calculateThrowsFinals(player,gameData) {
          return this.$parent.calculateThrowsFinals(player,gameData);
      },
      getScorecardById: function(scorecard_id) {
        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard_id;
        var token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          this.gameData = response.data;
          this.isLoading = false;
        }, (error) => {
          alert(error);
        });
      },

      calculateThrowPoints: function (player) {
          var arr = [];
          if (this.gameData && this.gameData.rounds != null) {
              arr.push({label: '0', value: this.calculateAxeHit(player, this.gameData, 0)});
              arr.push({label: '1', value: this.calculateAxeHit(player, this.gameData, 1)});
              arr.push({label: '2', value: this.calculateAxeHit(player, this.gameData, 2)});
              arr.push({label: '3', value: this.calculateAxeHit(player, this.gameData, 3)});
              arr.push({label: '4', value: this.calculateAxeHit(player, this.gameData, 4)});
              arr.push({label: '5', value: this.calculateAxeHit(player, this.gameData, 5)});
          } else {
              arr.push({label: '0', value: 0});
              arr.push({label: '1', value: 0});
              arr.push({label: '2', value: 0});
              arr.push({label: '3', value: 0});
              arr.push({label: '4', value: 0});
              arr.push({label: '5', value: 0});
          }
          return arr;
      },
      calculateAxeHit: function (player, scorecard, basicScore) {
          //console.log("calculateAxeHit - player id: " + player.id + ", basicScore: " + basicScore);
          var playerId = player.id;
          var total = 0;
          var basicScore = parseInt(basicScore);
          var rounds = 0;
          var throws = 0;
          var total_throws = 0;
          for(var x = 0; x < scorecard.rounds.length; x++) {
              var round = scorecard.rounds[x];
              //rounds = scorecard.rounds.length;
              if (round.title != "Practice") {
                  for (var y = 0; y < round.matches.length; y++) {
                      var match = round.matches[y];
                      for (var z = 0; z < match.matchPlayers.length; z++) {
                          var matchPlayer = match.matchPlayers[z];
                          var matchPlayerId = matchPlayer.id;
                          if (matchPlayerId == playerId) {
                              for (var a = 0; a < matchPlayer.throws.length; a++) {
                                  throws = matchPlayer.throws.length;
                                  var pThrow = matchPlayer.throws[a];
                                  var bScore = parseInt(pThrow.basicScore);
                                  if (bScore === basicScore) {
                                      total++;
                                  }
                              }
                          }
                      }
                  }
              }
          }
          /*
          total_throws = rounds * throws;
          var avg = (total / total_throws)*100;
          var retStr = basicScore + ": " + total + " (" + avg.toFixed(0) + "%)";
          return retStr;
          */
          return total;
      },


    },
    mounted(){
      //get the id from the URL
      //console.log("this.$route",this.$route);
      
      var id = this.$route.params.scorecard_id;
      //alert("loading scorecard id: " + id);
      this.getScorecardById(id);
    }
}
</script>

<style lang="scss" scoped>
.score {
  background-color: black;
  overflow-y: auto;
}
</style>